enum RefundStatusEnum {
	Refunded = 'refunded',
	PartiallyRefuned = 'partiallyRefunded',
	Pending = 'pending',
	Failed = 'failed',
}

export default RefundStatusEnum;
